import axios from "axios";
import { getRoles } from "../helpers/authHelper";

export interface User {
  userID: string;
  userName: string;
  firstName: string;
  middleName: string;
  lastName: string;
  displayName: string;
  email: string;
  profile: {
    biaNumber: number;
    organizationCodeNumber: number;
  };
  roles: string;
  status: string;
}

export const listOrganizationAgencies = async () => {
  try {
    let endpoint = "";
    if (getRoles().includes("CORA_Admin"))
      endpoint = `${
        process.env.REACT_APP_API
      }/User/list-organization-users?OrganizationID=${-1}`;
    else endpoint = `${process.env.REACT_APP_API}/User/list-users`;

    const response = await axios.get(endpoint);

    return response.data;
  } catch (error) {
    console.error(error);
    const result: string[] = [];
    return result;
  }
};
